






































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import RunScriptDataSection from "./RunScriptDataSection.vue";

export default Vue.extend({
  components: {
    Modal,
    RunScriptDataSection,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "75rem",
      withTopRightCloseBtn: true,
    };

    const run_script = () => {
      emit("submit");
    };

    return {
      config,
      run_script,
    };
  },
});
